import apiClient from "./api.client.service";
import { ApiKey } from "../Entities/ApiKey";

class ApiKeyService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async generateAPIKey(): Promise<ApiKey | null> {
    try {
      const response = await apiClient.post(`${this.APIBaseUrl}/admin/api/key`);
      return response.data || null;
    } catch (error: any) {
      console.error("Error generating API key:", error);
      return null;
    }
  }

  async getAPIKeys(): Promise<ApiKey[]> {
    try {
      const response = await apiClient.get(`${this.APIBaseUrl}/admin/api/key`);
      return response.data || [];
    } catch (error: any) {
      console.error("Error getting API keys:", error);
      return [];
    }
  }

  async getAPIKeyById(id: string): Promise<ApiKey | null> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/api/key/${id}`
      );
      return response.data || null;
    } catch (error: any) {
      console.error("Error getting API key by id:", error);
      return null;
    }
  }

  async updateAPIKey(
    id: string,
    status: "active" | "inactive"
  ): Promise<ApiKey | null> {
    try {
      const response = await apiClient.put(
        `${this.APIBaseUrl}/admin/api/key/${id}`,
        { status }
      );
      return response.data || null;
    } catch (error: any) {
      console.error("Error updating API key:", error);
      return null;
    }
  }
}

const apiKeyService = new ApiKeyService();

export default apiKeyService;
